import RacialTraitFeatureSnippet from './RacialTraitFeatureSnippet';

export default RacialTraitFeatureSnippet;
export { RacialTraitFeatureSnippet };
